import autoMarkConversationAsRead from '../../helpers/autoMarkConversationAsRead';
import autoMarkItemAsRead from '../../helpers/autoMarkItemAsRead';
import markReadStore from '../../store/Store';
import { getViewFilterForTable } from 'owa-mail-list-store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Set the auto mark as read timer
 * @param id the conversation id or item id used to set the timer
 * @param state the AutoMarkAsReadTimerState which contains mark read store and delay time
 */
export var setAutoMarkAsReadTimer = action('setAutoMarkAsReadTimer')(select({
    markAsReadDelaytime: function () { return getUserConfiguration().UserOptions.MarkAsReadDelaytime; },
    store: function () { return markReadStore; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function setAutoMarkAsReadTimer(id, state) {
    var markAsReadDelaytime = state.markAsReadDelaytime, store = state.store, userOptions = state.userOptions;
    var tableView = getSelectedTableView();
    if (!tableView || getViewFilterForTable(tableView) == 'Unread') {
        // Do not setup the timer if
        // - tableView is undefined, this could happen when RP is opened from photohub
        // - or user is in Unread view filter, or the user option setting is not mark as read on delayed
        return;
    }
    if (userOptions.PreviewMarkAsRead == 'Delayed') {
        // Setup the timer if PreviewMarkAsRead is on delayed
        store.markAsReadTimerTask = setTimeout(function () {
            onMarkAsReadTimeout(id, tableView);
        }, markAsReadDelaytime * 1000);
    }
}));
/**
 * Clear the auto mark as read timer
 * @param state the state which contains the mark read store
 */
export var clearAutoMarkAsReadTimer = action('clearAutoMarkAsReadTimer')(select({
    store: function () { return markReadStore; },
})(function clearAutoMarkAsReadTimer(state) {
    if (state.store.markAsReadTimerTask) {
        clearTimeout(state.store.markAsReadTimerTask);
        state.store.markAsReadTimerTask = null;
    }
}));
/**
 * Callback when markAsReadTimer timeout
 * @param id the conversation id or item id to be marked as read
 * @param tableView the table view
 */
var onMarkAsReadTimeout = action('setMarkAsReadTimer:timeout')(function (id, tableView) {
    clearAutoMarkAsReadTimer();
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            autoMarkConversationAsRead(id, tableView);
            break;
        case 1 /* Message */:
            autoMarkItemAsRead(id, tableView);
            break;
    }
});
//# sourceMappingURL=autoMarkReadTimer.js.map